import { BoxProps, Box } from '@chakra-ui/react';

export const Tag: React.FC<BoxProps> = props => (
  <Box
    bg="green.50"
    color="green.500"
    borderRadius="md"
    px="2"
    py="1"
    fontSize=".65rem"
    fontWeight="bold"
    {...props}
  />
);
